/**
 * [微企收款管理]
 * @author: Fu Xiaochun
 * @date: 2021-09-01 
 */

import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import { connect } from 'react-redux';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import { SearchBox, SearchItem } from '@/components/Layout';
import TableList from './components/TableList';
import KeepAlive from '@/routes/KeepAlive';
import { XInput, XOKButton, XCancelButton, XDatePicker } from '@/components/xqxc_ui';
import { message, Modal } from 'antd';
import * as api from '@/apis/finance/microcollectionmanage';
import { getEnum } from '@/apis/common/index';
import CollectionOrderModal from './components/CollectionOrderModal';


function MicroCollectionManage(props){

    const [orderData, setOrderData] = useState({});
    const page = useRef({pageNum: 1, pageSize: 30});
    const [aliveInit, setAliveInit] = useState(false);
    const [receiptId, setReceiptId] = useState();
    const [payCompanyName, setPayCompanyName] = useState();
    const [receiveStartTime, setReceiveStartTime] = useState();
    const [receiveEndTime, setReceiveEndTime] = useState();
    const [reset, setReset] = useState();

    const [collectionOrderModalVisible, setCollectionOrderModalVisible] = useState(false);
    const [curItem, setCurItem] = useState(null);

    const [bizEnum, setBizEnum] = useState({});

    useEffect(()=>{

        // 设置面包屑
        props.setBreadcrumbPaths(props.match);
        getBizEnum();
    }, []);

    useEffect(()=>{
        aliveInit && search();
    }, [aliveInit]);

    useEffect(()=>{
        reset && search();
    }, [reset]);

    const initData = (data)=>{
        setAliveInit(true);
        setReceiptId(data.receiptId);
        setPayCompanyName(data.payCompanyName);
        setReceiveStartTime(data.receiveStartTime);
        setReceiveEndTime(data.receiveEndTime);
        page.current = {pageNum: data.pageNum, pageSize: data.pageSize};
    };

    const getBizEnum = ()=>{
        getEnum({enumName: 'SettleReceiptBusinessEnum'}).then(res=>{
            let enums = res.result;
            let temp = {};
            enums.forEach(v=>{
                temp[v.code] = v.value;
            });
            setBizEnum(temp);
        }).catch(err=>{
            message.error(err.message);
        });
    };

    const search = ()=>{
        const params = {
            listSearchParam: {
                receiptId,
                payCompanyName,
                receiveStartTime,
                receiveEndTime,
            },
            pageNum: page.current.pageNum,
            pageSize: page.current.pageSize
        };
        api.collectionOrderList(params).then(res=>{
            setOrderData(res.result);
        }).catch(err=>{
            message.error(err.message);
        });
    };

    const onReset = ()=>{
        setReceiptId();
        setPayCompanyName();
        setReceiveStartTime();
        setReceiveEndTime();
        setReset(Date.now());
        page.current = {pageNum: 1, pageSize: 30};
    };

    const tableAction = (type, item)=>{
        switch (type){
            case 'detail':
                // 跳转详情
                props.history.push('/home/finance/microcollectionmanage/detail/'+item.id);
                break;
            case 'edit': 
                // 编辑
                setCurItem(item);
                setCollectionOrderModalVisible(true);
                break;
            case 'confirm':
                // 确认收款
                Modal.confirm({
                    title: '确认收到款项？',
                    onOk() {
                        api.confirmCollectionOrder({receiptId: item.id}).then(res=>{
                            message.success('操作成功！');
                            search();
                        }).catch(err=>{
                            message.error(err.message);
                        });
                    },
                  });
                
                break;
            default: 
                // nothing to do
        }
    };

    const onPageChange = (pageSize, pageNum)=>{
        page.current = {pageNum, pageSize};
        search();
    };

    const createCollectionOrder = ()=>{
        setCurItem();
        setCollectionOrderModalVisible(true);
    };

    const collectionOrderFormOnSave = (data)=>{
        search();
        closeCollectionOrderForm();
    };

    const closeCollectionOrderForm = ()=>{
        setCollectionOrderModalVisible(false);
    };
    
    return (
    <KeepAlive render={(state) => {
        if (!aliveInit) {
            initData(state);
        }
    }}>
        <div className={styles.flexBoxContainer}>
            <SearchBox>
                <SearchItem>
                    <XInput
                        inputStyle={{ width: 200 }}
                        label='收款单号'
                        placeholder='请输入'
                        value={receiptId}
                        bindThis={setReceiptId}
                        bindName='receiptId'
                    />
                </SearchItem>
                <SearchItem>
                    <XInput
                        inputStyle={{ width: 200 }}
                        label='企业名称'
                        placeholder='请输入'
                        value={payCompanyName}
                        bindThis={setPayCompanyName}
                        bindName='payCompanyName'
                    />
                </SearchItem>
                <SearchItem>
                    <XDatePicker
                        label='收款日期'
                        datePickerStyle={{ width: 160 }}
                        value={receiveStartTime}
                        bindThis={setReceiveStartTime}
                        bindName='receiveStartTime'
                        showTime={false}
                        defaultTime='00:00:00'
                        isFormat
                    />
                    <XDatePicker
                        style={{ marginRight: 20 }}
                        datePickerStyle={{ width: 160 }}
                        label=''
                        value={receiveEndTime}
                        bindThis={setReceiveEndTime}
                        bindName='receiveEndTime'
                        showTime={false}
                        defaultTime='23:59:59'
                        isFormat
                    />
                </SearchItem>
                <SearchItem>
                    <XOKButton
                        style={{ marginLeft: '20px', width: '60px' }}
                        label='查询'
                        onClick={search}
                    />
                    <XCancelButton
                        style={{ marginLeft: '20px', width: '60px' }}
                        label='重置'
                        onClick={onReset}
                    />
                </SearchItem>
            </SearchBox>
            <div className={styles.row2}>
                <XOKButton
                    style={{ width: '120px' }}
                    label='新建收款单'
                    onClick={createCollectionOrder}
                />
            </div>
            <TableList bizEnum={bizEnum} renderData={orderData} tableAction={tableAction} paginationChange={onPageChange} />
            {collectionOrderModalVisible ? <CollectionOrderModal detail={curItem} onSave={collectionOrderFormOnSave} onClose={closeCollectionOrderForm}/> : null}
        </div>
    </KeepAlive>
    );
}

MicroCollectionManage.propTypes = {
    history: PropTypes.object,//路由对象
    match: PropTypes.object, // 路由match对象
    setBreadcrumbPaths: PropTypes.func
};

export default connect(null, { setBreadcrumbPaths })(MicroCollectionManage);